import * as DateUtils from './dateUtils';

export class ParamUrlBuilder {
    constructor(baseUrl) {
        if (!baseUrl) {
            throw 'BaseUrl argument needed!';
        }

        this.baseUrl = baseUrl;
        this.params = {};
    }

    setUserId(userId) {
        this.params.userId = `user_id=${encodeURIComponent(userId)}`;
        return this;
    }

    setTeamIds(teamIdsCsv) {
        this.params.teamIds = `team_ids=${encodeURIComponent(teamIdsCsv)}`;
        return this;
    }

    setTeamId(teamId) {
        this.params.teamId = `team_id=${encodeURIComponent(teamId)}`;
        return this;
    }

    setStartDate(startDate) {
        this.params.startDate = `start_date=${startDate.format(
            DateUtils.CALENDAR_FORMAT
        )}`;
        return this;
    }

    setEndDate(endDate) {
        this.params.endDate = `end_date=${endDate.format(
            DateUtils.CALENDAR_FORMAT
        )}`;
        return this;
    }

    setExerciseId(exerciseId) {
        this.params.exerciseId = `exercise_id=${encodeURIComponent(
            exerciseId
        )}`;
        return this;
    }

    setUseMetric(useMetric) {
        const enabled = useMetric ? 1 : 0;
        this.params.useMetric = `use_metric=${enabled}`;
        return this;
    }

    buildUrl() {
        let paramString = Object.values(this.params).join('&');
        if (paramString.length > 0) {
            paramString = '?' + paramString;
        }
        return this.baseUrl + paramString;
    }
}
